import {
	contractDamageSchema,
	contractHazardSchema,
	suretyBondFormTypeSchema,
	suretyBondIssuanceMethodSchema,
	Types,
	usStateOrTerritorySchema,
} from "@inrev/common";
import * as z from "zod";

/**
 * A scope-of-work entry. Labels come from catalog hydration on bond/quote load.
 */
const scopeOfWorkItemSchema = z.strictObject({
	code: z.string(),
	label: z.string().nullable(),
});
export type ScopeOfWorkItem = z.infer<typeof scopeOfWorkItemSchema>;

/**
 * `city` and `state` are where the project is built, not anyone's address: the project record
 * holds no street or zip, and a job's location is what an underwriter reads for the account's
 * home market.
 */
export const projectSchema = z.strictObject({
	name: z.string().nullable(),
	description: z.string().nullable(),
	city: z.string().nullable(),
	state: usStateOrTerritorySchema.nullable(),
	scopeOfWork: z.array(scopeOfWorkItemSchema),
	monthsToComplete: z.number().nullable(),
	warrantyMonths: z.number().nullable(),
	hazards: z.array(contractHazardSchema),
	damages: z.array(contractDamageSchema),
});
export type Project = z.infer<typeof projectSchema>;

/** The obligee's address stays out: only who they are and what role they play on the job. */
export const obligeeSchema = z.strictObject({
	name: z.string(),
	role: Types.SuretyBond.Obligee.roleSchema.nullable(),
});
export type Obligee = z.infer<typeof obligeeSchema>;

export const bondFormSchema = z.strictObject({
	title: z.string().nullable(),
	formType: suretyBondFormTypeSchema.nullable(),
	issuanceMethod: suretyBondIssuanceMethodSchema.nullable(),
});
export type BondForm = z.infer<typeof bondFormSchema>;
